import { Filter } from '../../interfaces/Interfaces'

const state = {
  yAxisMaxValue: 3,
  showScenes: false,
  removeNoise: true,
  genderSplit: false,
  ageGroupSplit: false,
  filterIndex: -1,
}

const mutations = {
  setYAxisMaxValue: (state: any, value: number): number => state.yAxisMaxValue = value,
  toggleShowScenes: (state: any, value: boolean): boolean => state.showScenes = value,
  toggleRemoveNoise: (): boolean => state.removeNoise = !state.removeNoise,
  toggleGenderSplit: (): void => {
    if (state.ageGroupSplit) state.ageGroupSplit = false
    state.filterIndex = -1
    state.genderSplit = !state.genderSplit
  },
  toggleAgeGroupSplit: (): void => {
    if (state.genderSplit) state.genderSplit = false
    state.filterIndex = -1
    state.ageGroupSplit = !state.ageGroupSplit
  },
  toggleFilterSplit: (index: number): void => {
    if (state.genderSplit) state.genderSplit = false
    if (state.ageGroupSplit) state.ageGroupSplit = false
    state.filterIndex = index
  },
  disableDataSplits: ():void => {
    if (state.genderSplit) state.genderSplit = false
    if (state.ageGroupSplit) state.ageGroupSplit = false
    state.filterIndex = -1
  }
}

const getters = {
  getYAxisMaxValue: (): number => state.yAxisMaxValue
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}
